import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getFirestore, doc, updateDoc } from 'firebase/firestore';
import emailjs from 'emailjs-com';
//import './SchoolPaymentSuccess.css'

const SchoolPaymentSuccess = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [schoolName, setSchoolName] = useState('');

  useEffect(() => {
    const updatePaymentStatus = async () => {
      try {
        // Get the pending school membership ID from localStorage
        const schoolId = localStorage.getItem('pendingSchoolMembershipId');
        
        if (!schoolId) {
          throw new Error('No pending school membership found');
        }
        
        const db = getFirestore();
        
        // Update the school membership document in Firestore
        const schoolRef = doc(db, 'schoolMemberships', schoolId);
        await updateDoc(schoolRef, {
          paymentStatus: 'paid',
          paymentDate: new Date(),
          membershipType: 'school',
          membershipStatus: 'active',
          expirationDate: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000), // 1 year from now
        });
        
        console.log('School membership updated successfully');
        
        // Get the school name for display
        const schoolData = localStorage.getItem('schoolMembershipData');
        if (schoolData) {
          const parsedData = JSON.parse(schoolData);
          setSchoolName(parsedData.schoolName);
        }
        
        // Send email notification
        sendEmailNotification(schoolId);
        
        // Clear the localStorage items
        localStorage.removeItem('pendingSchoolMembershipId');
        localStorage.removeItem('schoolMembershipData');
        
        setLoading(false);
      } catch (error) {
        console.error('Error updating school membership:', error);
        setError('Failed to update payment status. Please contact support.');
        setLoading(false);
      }
    };
    
    updatePaymentStatus();
  }, [navigate]);
  
  const sendEmailNotification = (schoolId) => {
    // Prepare the template parameters for EmailJS
    const templateParams = {
      name: 'School Membership System',
      email: 'admin@nuralhuda.ca', // Admin email
      message: `A new school has purchased a membership (ID: ${schoolId}). Please check the admin dashboard for details.`
    };
    
    // Replace with your EmailJS credentials
    const serviceID = 'service_rpg9tsq';
    const templateID = 'template_t06rk76';
    const userID = '2c0CoID2ucNYaKVFe';
    
    emailjs
      .send(serviceID, templateID, templateParams, userID)
      .then(
        (response) => {
          console.log('Email notification sent successfully', response.status, response.text);
        },
        (err) => {
          console.error('Failed to send email notification:', err);
        }
      );
  };
  
  const handleGoHome = () => {
    navigate('/');
  };
  
  if (loading) {
    return <div className="loader">Updating membership status...</div>;
  }
  
  return (

    
    <div className="payment-success-container">
      {error ? (
        <div className="error-message">{error}</div>
      ) : (
        <>
          <h2>School Membership Payment Successful!</h2>
          <p>
            Thank you for becoming a Nur Al Huda member school! Your school now has access to our
            full range of AI-powered educational tools and resources. Our team will contact you
            shortly to schedule your teacher training sessions and implementation consultation.
          </p>
          {schoolName && <p className="school-name">Welcome aboard, {schoolName}!</p>}
          <div className="membership-benefits">
            <h3>Your Benefits Include:</h3>
            <ul>
              <li>Access for all school administrators</li>
              <li>5 teacher training sessions</li>
              <li>AI implementation consultation</li>
              <li>Monthly newsletter with AI updates</li>
              <li>Priority support</li>
            </ul>
          </div>
          <div className="next-steps">
            <h3>Next Steps:</h3>
            <ol>
              <li>Check your email for a welcome packet</li>
              <li>Schedule your first training session</li>
              <li>Explore the admin dashboard</li>
            </ol>
          </div>
          <div className="button-container">
            <button onClick={handleGoHome} className="primary-button">Return to Homepage</button>
          </div>
        </>
      )}
    </div>

  );
};

export default SchoolPaymentSuccess;